import React from 'react';
import { withStyles, LinearProgress } from '@material-ui/core';
import NPDatatable from '../../../np-components/Datatable';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const styles = theme => ({
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },
    chipCustomerActive: {
        color: theme.palette.success.dark,
        marginTop: 8.5,
        fontSize: 15
    },
    chipCustomerInactive: {
        color: theme.palette.error.dark,
        padding: 1,
        margin: 1,
        fontSize: 15
    },
    formControl: {
        marginLeft: 24,
        minWidth: 120,
    },
    container: {
        margin: theme.spacing(1),
        padding: '2rem',
        paddingBottom: '8rem'
    },
    root: {
        height: '100%',
        marginBottom: '0px'
    }

});

const CustomerErasures = props => {
    const { classes, years, erasures, year, columnsState, setYear, saveColumnsFilter, activeCustomer, handleCreate, translations } = props;

    let tableID = 'CustomerErasure';
    let visible = columnsState && columnsState[tableID];

    const handleChange = (event) => {
        setYear(event.target.value);
    };

    const columns = [
        {
            displayName: translations['year_month'] || 'Year/Month',
            backendName: 'Year/Month',
            options: {
                align: 'left',
                sortable: false,
                searchable: false,
                visible: visible ? visible['Year/Month'] : true,
            }
        },
        {
            displayName: translations['overall_erased'] || 'Overall erased',
            backendName: 'OveralErased',
            options: {
                align: 'left',
                sortable: false,
                searchable: false,
                visible: visible ? visible['OveralErased'] : true,
            }
        },
        {
            displayName: translations['pc_product'] || 'Work',
            backendName: 'Desktop',
            options: {
                align: 'left',
                sortable: false,
                visible: visible ? visible['Desktop'] : true,
            }
        },
        {
            displayName: translations['mobile'] || 'Mobile',
            backendName: 'Mobile',
            options: {
                align: 'left',
                sortable: false,
                searchable: false,
                visible: visible ? visible['Mobile'] : true,
            }
        },
        {
            displayName: translations['storage_product'] || 'Single disk-drives',
            backendName: 'Storage',
            options: {
                align: 'left',
                sortable: false,
                searchable: false,
                visible: visible ? visible['Storage'] : true,
            }
        }
    ];

    let backendNames = [];
    columns.map(column => { if (column.backendName !== 'Action') backendNames.push(column.backendName); return null; })

    const yearID = years.filter(y => y.value + '' === year + '').length > 0;

    const customFilterToolbar = () => {
        return <>
            <form className={classes.root} autoComplete="off">
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="years-simple">{translations['years'] || 'Year(s)'}</InputLabel>
                    <Select
                        value={yearID ? year : ''}
                        onChange={handleChange}
                        inputProps={{
                            name: 'years',
                            id: 'years-simple',
                        }}
                    >
                        {
                            (years ? years : []).map(year =>
                                <MenuItem key={year.value} value={year.value}>{year.displayValue}</MenuItem>
                            )
                        }

                    </Select>
                    <FormHelperText>{translations['years_select'] || 'Please select year(s)'}</FormHelperText>
                </FormControl>
            </form>
            <p style={{ marginTop: 20, marginLeft: 23, marginBottom: 0 }}> {`${translations['total_erasure'] || "Total erasures"} (${translations['selected_year'] || "selected year"}) = ${years.find(yearObj => year === yearObj.value)?.erasures ?? 0}`}</p>
            <p style={{ marginTop: 5, marginLeft: 23, marginBottom: 0 }}> {`${translations['total_erasure'] || "Total erasures"}  = ${years.find(yearObj => 'all' === yearObj.value)?.erasures ?? 0}`}</p>
        </>
    };

    const tableOptions = {
        isSelectable: false,
        tableSearch: false,
        tableID: tableID,
        saveColumn: true,
        selectOptions: { printing: false, generatingReport: false, deleting: false, creating: false },
        rowsPerPage: 0,
        page: 0,
        count: 0,
        rowsPerPageOptions: [20, 10, 20, 50, 75, 100, 'All'],
        tableTitle: translations['erasures'] || 'Erasures',
        noMatch: translations['table_no_match'] || "Sorry, no matching records found",
        onTableChange: false,
        disablePagination: true,
        onSaveFilter: (columns) => {
            let objToSendColumn = {}
            let objColumns = {}
            columns.map(column => {
                objColumns[`${column.backendName}`] = column.options.visible
                return objColumns
            })
            objToSendColumn[`${tableID}`] = objColumns
            saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        }

    };

    return (
        <div className={classes.container}>
            {erasures.loading ? <LinearProgress color="primary" /> : null}
            <NPDatatable translations={translations} customStyles={classes} handleCreate={handleCreate} data={erasures.erasure} columns={columns} options={tableOptions} customFilterToolbar={customFilterToolbar} />
        </div>
    );
}

export default (withStyles(styles)(CustomerErasures));